module.exports = __webpack_public_path__ + "img/Nyromantikk_Andre_kunstformer_Munch.c4ee7322.jpg";